import { ref } from 'vue';
import { dashboardApiClient } from '@api-client/dashboard';
import type { ResType } from '@api-client/typeUtils';
import { currentWebsiteId } from './MyWebsitesStore';

const getSupportStripeStatusApiPath = dashboardApiClient.website.partner_support.stripe_account_status[':websiteId'].$get;
const getMarketingStripeStatusApiPath = dashboardApiClient.website.partner_marketing.stripe_account_status[':websiteId'].$get;

type SupportStripeStatus = ResType<typeof getSupportStripeStatusApiPath>["data"];
type MarketingStripeStatus = ResType<typeof getMarketingStripeStatusApiPath>["data"];

export const currentSupportStripeStatus = ref<SupportStripeStatus | null>(null);
export const currentMarketingStripeStatus = ref<MarketingStripeStatus | null>(null);

export const checkStripeAccountReady = (
    stripeStatus: SupportStripeStatus | MarketingStripeStatus | null
) => {
    return (
        stripeStatus?.hasAccount &&
        stripeStatus.account?.details_submitted &&
        stripeStatus.account?.charges_enabled &&
        stripeStatus.alerts.length === 0
    ) || false;
}

export async function loadCurrentSupportStripeStatus() {
    const { data, error } = await (await getSupportStripeStatusApiPath({
        param: {
            websiteId: currentWebsiteId.value ?? '',
        }
    })).json();
    if (error) {
        console.error(error);
    } else {
        currentSupportStripeStatus.value = data;
    }
}

export async function loadCurrentMarketingStripeStatus() {
    const { data, error } = await (await getMarketingStripeStatusApiPath({
        param: {
            websiteId: currentWebsiteId.value ?? '',
        }
    })).json();
    if (error) {
        console.error(error);
    } else {
        currentMarketingStripeStatus.value = data;
    }
}

export async function loadCurrentWebsiteStripeStatuses() {
    await Promise.all([
        loadCurrentSupportStripeStatus(),
        loadCurrentMarketingStripeStatus(),
    ]);
}
